import { useState, useEffect } from "react";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button, Modal, Col, Row, Spinner, Table } from "react-bootstrap";
import { TextField } from "@mui/material";
import { FormControlLabel } from "@mui/material";
import { Checkbox } from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import ApiAccount from "../../../core/api/api.account";
import { Switch } from "@mui/material";
import SwalMessage from "../_Components/SwalMessage";
import ApiSupplier from "../../../core/api/api.supplier";
import CardNumberFormat from "../_Components/CardNumberFormat";
import SelectComponent from "../_Components/ReactSelectComponent";
import { numberRegex } from "../../../core/utils/tools";

export const AddEditeModal = ({ showModalAccount, setShowModalAccount, selectedAccountId }) => {
  const [refresh, setRefresh] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [accountCardList, setAccountCardList] = useState([]);
  const [agencyList, setAgencyList] = useState([]);
  const [idAccountCard, setIdAccountCard] = useState(0);
  const handleClose = () => {
    setShowModalAccount(false);
  };
  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
  } = useForm({
    defaultValues: { id: 0 },
  });

  useEffect(() => {
    (async () => {
      try {
        let response = await ApiSupplier.getAllSuppliersName();
        setAgencyList(response);
      } catch (error) {
      }
    })();
    return () => { };
  }, []);
  useEffect(() => {
    (async () => {
      try {
        if (selectedAccountId > 0) {
          // دریافت اطلاعات حساب جهت ویرایش
          let response = await ApiAccount.getAccountById(selectedAccountId);
          if (response.succeeded == true) {
            // مقدار اولیه
            setAccountCardList(response.data.accountCards);
            setValue("id", response.data.id);
            setValue("bank", response.data.bank);
            setValue("accountNumber", response.data.accountNumber);
            setValue("accountOwnerName", response.data.accountOwnerName);
            setValue("description", response.data.description);
            setValue("shebaNumber", response.data.shebaNumber);
            setValue("status", response.data.status);
            setValue("type", _.toString(response.data.type));
            setValue("supplierId", agencyList?.map(item => ({
              value: item.id,
              label: item.companyName
            })).find(item => item.value == response.data.supplierId));

            if (response.data.type === 3) {
              setValue("cardNumber", response.data.cardNumber);
              setValue("cardOwnerName", response.data.cardOwnerName);
            }

            if (response.data.id > 0 && response.data.type !== 3) setShowButton(true);
          }
        }
      } catch (error) {
      }
    })();
    return () => { };
  }, [refresh, agencyList]);

  const onSubmit = async (data) => {
    if (data.supplierId) data.supplierId = data.supplierId?.value

    try {
      // if (_.toNumber(data.type) === 2 && !(_.isNumber(data.supplierId) && _.toNumber(data.supplierId) > 0)) {
      //     SwalMessage({ title: "برای حسابهای خارجی آژانس باید تعریف شود", iSsuccess: false });
      //     return;
      // }
      // به کد های سرور اجازه بدیم خودش بره و آژانس مناسب پیدا کند
      // if (_.toNumber(data.type) === 1 || _.toNumber(data.type) === 3) {
      //     data.supplierId = null;
      // }

      let response = null;
      if (_.isNumber(data.id) && _.toNumber(data.id) > 0) {
        //شماره کارت و نام صاحب کارت برای حسابهای کاربر معتبر می باشد
        if (data.type !== "3") {
          data.cardNumber = "";
          data.cardOwnerName = "";
        }
        response = await ApiAccount.updateAccount(data);
      } else response = await ApiAccount.createAccount(data);

      if (response.succeeded == true) document.getElementById("submitButton").click();

      setShowModalAccount(false)
      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    } catch (error) {
    }
  };

  const onSubmit2 = async () => {
    try {
      let data = {};
      data.id = idAccountCard;
      data.status = getValues("status");
      data.cardNumber = getValues("cardNumber");
      data.cardOwnerName = getValues("cardOwnerName");
      data.accountId = getValues("id");

      if (!_.isNumber(data.accountId) || _.toNumber(data.accountId) <= 0) {
        SwalMessage({ title: "ابتدا حساب باید درج شود", iSsuccess: false });
        return;
      }
      if (getValues("type") == 3) {
        SwalMessage({ title: "حسابهای کاربران تنها شامل یک شماره کارت می توانند باشند", iSsuccess: false });
        return;
      }

      let response = null;
      if (_.isNumber(data.id) && _.toNumber(data.id) > 0) response = await ApiAccount.updateAccountCard(data);
      else response = await ApiAccount.createAccountCard(data);

      if (response.succeeded == true) setRefresh(!refresh);


      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    } catch (error) {
    }
  };

  const clean = () => {
    setIdAccountCard(0);
    setValue("cardNumber", "");
    setValue("cardOwnerName", "");
  };

  const handleChange = (item) => (event) => {
    (async () => {
      try {
        const response = await ApiAccount.changeAccountCardStatus({ id: item.id, status: !item.status });
        if (response.succeeded == true) setRefresh(!refresh);

        SwalMessage({ title: response.message, iSsuccess: response.succeeded });
      } catch (error) {
      }
    })();
    return () => { };
  };

  const editItem = (item) => (event) => {
    setIdAccountCard(item.id);
    setValue("cardNumber", item.cardNumber);
    setValue("cardOwnerName", item.cardOwnerName);
  };

  return (
    <div>
      {/* Start Modal */}
      {/* <Modal centered size='md' show={show} onHide={handleClose}> */}
      <Modal centered size="md" onHide={handleClose} show={showModalAccount}>
        <form id="form" onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            {selectedAccountId != 0 ? (
              <Modal.Title> ویرایش حساب </Modal.Title>
            ) : (
              <Modal.Title> افزودن حساب</Modal.Title>
            )}
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col xs="12">
                <Controller
                  name="bank"
                  control={control}
                  rules={{ required: true }}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="نام بانک"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={onChange}
                    />
                  )}
                />
                {errors.bank && <span className="text-danger">لطفا نام بانک را وارد نمایید</span>}
              </Col>
              <Col xs="12">
                <Controller
                  name="accountNumber"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="شماره حساب"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={(e) => {
                        if (e.target.value && !numberRegex.test(e.target.value)) {
                          e.target.value = getValues("accountNumber")
                          return
                        }
                        onChange(e)
                      }}
                    />
                  )}
                />
                {errors.accountNumber && <span className="text-danger">لطفا شماره حساب را وارد نمایید</span>}
              </Col>
              <Col xs="12">
                <Controller
                  name="accountOwnerName"
                  control={control}
                  rules={{ required: true }}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="نام صاحب حساب"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={onChange}
                    />
                  )}
                />
                {errors.bank && <span className="text-danger">لطفا نام صاحب حساب را وارد نمایید</span>}
              </Col>
              <Col xs="12">
                <Controller
                  name="shebaNumber"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="شماره شبا"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={onChange}
                    />
                  )}
                />
              </Col>
              <Col xs="12">
                <Controller
                  name="description"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="توضیحات"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={onChange}
                    />
                  )}
                />
              </Col>
              {/* <Col xs='12'>
                                        <Controller
                                            name="type"
                                            control={control}
                                            rules={{ required: true, }}
                                            render={({ field: { onChange, value } }) => (
                                                <TextField
                                                    id="outlined-select-currency"
                                                    select
                                                    label="گروه"
                                                    className="w-100 mt-2"
                                                    variant="outlined"
                                                    size='small'
                                                    value={value || ""}
                                                    onChange={onChange}
                                                >
                                                    <MenuItem key='1' value='1'>داخلی</MenuItem>
                                                    <MenuItem key='2' value='2'>خارجی</MenuItem>
                                                    <MenuItem key='3' value='3'>کاربر</MenuItem>
                                                </TextField>
                                            )}
                                        />
                                        {errors.type && <span>لطفا گروه را وارد نمایید</span>}
                                    </Col> */}
              <Col xs="12">
                <Controller
                  name="supplierId"
                  control={control}
                  render={({ field }) => (
                    <SelectComponent
                      options={agencyList?.map(item => ({
                        value: item.id,
                        label: item.companyName
                      }))}
                      placeholder="تامین کننده"
                      className="w-100 mt-5"
                      variant="outlined"
                      size="small"
                      field={field}
                    />
                  )}
                />
                {errors.supplierId && <span className="text-danger">لطفا یک تامین کننده انتخاب کنید </span>}
              </Col>
              <div className={showButton && idAccountCard > 0 ? "border rounded-3 py-3 my-5 " : ""}>
                <Col xs="12" className="px-0 pt-3">
                  <Controller
                    name="cardNumber"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="شماره کارت"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={(e) => {
                          if (e.target.value && (!numberRegex.test(e.target.value) || e.target.value.length > 16)) {
                            e.target.value = getValues("accountNumber")
                            return
                          }
                          onChange(e)
                        }} />
                    )}
                  />
                </Col>
                <Col xs="12" className="px-0">
                  <Controller
                    name="cardOwnerName"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="نام صاحب کارت"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                </Col>
                {showButton && idAccountCard > 0 && (
                  <Col xs="12 px-0" className="pt-4">
                    <Button variant="success" className="mr-2" onClick={onSubmit2}>
                      <SaveIcon /> ویرایش
                    </Button>
                    <Button variant="danger" onClick={clean}>
                      <DeleteIcon /> پاک کردن
                    </Button>
                  </Col>
                )}
              </div>

              <Col xs="12">
                <FormControlLabel
                  control={
                    <Controller
                      name="status"
                      control={control}
                      render={({ field: { onChange, onBlur, value = false, name, ref } }) => (
                        <Checkbox onBlur={onBlur} onChange={onChange} checked={value} inputRef={ref} color="primary" />
                      )}
                    />
                  }
                  label="فعال "
                />
              </Col>
            </Row>
            {!_.isEmpty(accountCardList) && showButton && (
              <>
                <div className="bg-secondary rounded-4 my-4 ">
                  <Table responsive className=" rounded-4">
                    <thead>
                      <tr className="">
                        <td className="bg-secondary" style={{ minWidth: "100px" }}>
                          نام صاحب کارت
                        </td>
                        <td className="bg-secondary text-center">شماره کارت</td>
                        <td className="bg-secondary text-center">وضعیت</td>
                        <td className="bg-secondary text-center">عملیات</td>
                      </tr>
                    </thead>
                    <tbody>
                      {accountCardList?.map((item, Index) => (
                        <tr key={Index}>
                          <td>{item.cardOwnerName}</td>
                          <td>
                            <CardNumberFormat number={item.cardNumber} />
                          </td>
                          <td>
                            <Switch
                              checked={item.status ? true : false}
                              value="row.original.active"
                              color="primary"
                              inputProps={{ "aria-label": "primary checkbox" }}
                              onChange={handleChange(item)}
                            />
                          </td>
                          <td>
                            <Button className="btn btn-light-primary btn-sm mr-2 btn-icon" onClick={editItem(item)}>
                              <i className="far fa-edit text-small"></i>
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
              <SaveIcon /> ذخیره
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
